<script setup lang="ts">
import { useI18nLocalize } from '@/i18n/i18nLocalize';
import { getTextVariant } from '@/utils/stringUtils';

const props = defineProps<{
  data?: object;
  totalRoom: number;
}>();

const { i18nLocale } = useI18nLocalize();
const { $t } = i18nLocale(props.data.lang);
</script>
<template>
  <tr class="border-top-1 border-top-solid border-900">
    <td class="pt-2 vertical-align-top">
      <table>
        <thead>
          <tr>
            <th class="hidden" v-for="time in 2" :key="time"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="2" class="pb-2">
              <ul class="no-bullets">
                <li class="text-base underline font-bold">{{ $t('client_copy.agency_information') }}</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="width-200px text-base">
              <ul class="no-bullets w-full">
                <li class="height-18px font-bold">{{ $t('common.labels.group_name') }}</li>
                <li class="height-18px font-bold">{{ $t('common.labels.type_of_quote') }}</li>
                <li class="height-18px font-bold">{{ $t('common.labels.number_of_passengers') }}</li>
              </ul>
            </td>
            <td colspan="2" class="width-200px text-left">
              <ul class="no-bullets w-full text-base">
                <li class="height-18px">
                  <div class="width-200px overflow-hidden text-overflow-ellipsis">{{ data.gName }}</div>
                </li>
                <li class="height-18px">
                  <div class="width-200px overflow-hidden text-overflow-ellipsis">{{ getTextVariant(data?.lang, data.gType, data.groupTypeFr) }}</div>
                </li>
                <li class="height-18px">
                  <div class="width-200px overflow-hidden text-overflow-ellipsis">{{ `${data.numberOfPassengers}  ${totalRoom ? `(${totalRoom} ${$t('client_copy.rooms')})` : ''}` }}</div>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
    <td class="pt-4 vertical-align-top flex justify-end">
      <table>
        <thead>
          <tr>
            <th class="hidden" v-for="time in 2" :key="time"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="2" class="width-200px text-base">
              <ul class="no-bullets w-full">
                <li class="height-18px font-bold">{{ $t('common.labels.agent') }}</li>
                <li class="height-18px font-bold">{{ $t('common.labels.agency_name') }}</li>
                <li class="height-18px font-bold">{{ $t('common.labels.phone') }}</li>
                <li class="height-18px font-bold">{{ $t('common.labels.email') }}</li>
              </ul>
            </td>
            <td colspan="2" class="width-200px text-left">
              <ul class="no-bullets w-full text-base">
                <li class="height-18px">
                  <div class="width-200px overflow-hidden text-overflow-ellipsis">{{ data.user }}</div>
                </li>
                <li class="height-18px">
                  <div class="width-200px overflow-hidden text-overflow-ellipsis">-</div>
                </li>
                <li class="height-18px">
                  <div class="width-200px overflow-hidden text-overflow-ellipsis">{{ data.phone }}</div>
                </li>
                <li class="height-18px">
                  <div class="width-200px overflow-hidden text-overflow-ellipsis">{{ data.email }}</div>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>
<style lang="scss" scoped>
.min-w-label {
  min-width: 16rem;
}
.justify-end {
  justify-content: flex-end;
}
</style>
